const formControlLabel = { styleOverrides: { root: { margin: 0 } } };

export default formControlLabel;
